// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__wPYBE","footer":"ModalCreateQualiphyProcedure_footer__1WwPk","additionData":"ModalCreateQualiphyProcedure_additionData__1R6QI"};